/**
 * HeroCentered Schema
 * Schema-driven settings
 */
export default {
  id: 'herocentered',
  version: 1,
  title: 'Hero: центрированный',
  description: 'Центрированный hero-блок: текст по центру с изображением сверху или снизу',
  icon: 'AlignCenter',
  category: 'hero',

  // Hero секции используют min-height, padding не применяется
  'x-styles': {
    paddingTop: 0,
    paddingBottom: 0
  },

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'badge',
          type: 'text',
          label: 'Бейдж',
          placeholder: 'Новинка, Версия 2.0 и т.д.',
          defaults: { size: 'sm', weight: 'medium', color: 'primary' }
        },
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Введите заголовок',
          defaults: { size: '5xl', weight: 'bold', color: 'inherit' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Введите описание',
          multiline: true,
          rows: 3,
          defaults: { size: 'lg', weight: 'normal', color: 'secondary' }
        }
      ]
    },
    {
      group: 'Изображение',
      fields: [
        {
          key: 'image',
          type: 'image',
          label: 'Изображение'
        },
        {
          key: 'imagePosition',
          type: 'select',
          label: 'Позиция изображения',
          options: [
            { value: 'top', label: 'Сверху' },
            { value: 'bottom', label: 'Снизу' }
          ]
        },
        {
          key: 'imageHeight',
          type: 'select',
          label: 'Высота изображения',
          options: [
            { value: 'small', label: 'Маленькая' },
            { value: 'medium', label: 'Средняя' },
            { value: 'large', label: 'Большая' }
          ]
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'height',
          type: 'select',
          label: 'Высота блока',
          mode: 'grid',
          columns: 2,
          options: [
            { value: 'auto', label: 'Авто' },
            { value: 'small', label: 'Маленькая' },
            { value: 'medium', label: 'Средняя' },
            { value: 'large', label: 'Большая' }
          ]
        }
      ]
    },
    {
      group: 'Кнопки',
      fields: [
        {
          key: 'buttons',
          type: 'buttonList',
          label: 'Кнопки действий',
          variants: ['primary', 'secondary', 'outline']
        }
      ]
    }
  ],

  default: {
    badge: { text: 'Новинка' },
    title: { text: 'Создавайте сайты за минуты' },
    subtitle: { text: 'Интуитивный конструктор для создания современных landing page без единой строчки кода' },
    image: 'https://placehold.co/1200x800/e2e8f0/64748b?text=Product+Screenshot',
    imagePosition: 'bottom',
    imageHeight: 'medium',
    height: 'auto',
    buttons: [
      { id: '1', text: 'Начать бесплатно', variant: 'primary', link: '#' },
      { id: '2', text: 'Демо', variant: 'outline', link: '#' }
    ]
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };
      ['badge', 'title', 'subtitle'].forEach(key => {
        if (typeof migrated[key] === 'string') {
          migrated[key] = { text: migrated[key] };
        }
      });
      return migrated;
    }
    return data;
  }
};
